// src/routes/modules/farmerRoutes.jsx
import { Route } from 'react-router-dom';
import ProtectedRoute from '../../components/ProtectedRoute';
import MasterLayout from '../../masterLayout/MasterLayout';

import ViewFarmers from '../../pages/ViewFarmers/ViewFarmers';
import AddFarmer from '../../pages/Farmer/AddFarmer';
import ViewFarmer from '../../pages/Farmer/ViewFarmer';
import EditFarmer from '../../pages/Farmer/EditFarmer';

const farmerRoutes = (
  <>
    <Route
      path="/farmer/view"
      element={
        <ProtectedRoute>
          <MasterLayout>
            <ViewFarmers />
          </MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/farmer/view/:id"
      element={
        <ProtectedRoute>
          <MasterLayout>
            <ViewFarmer />
          </MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/farmer/add"
      element={
        <ProtectedRoute>
          <MasterLayout>
            <AddFarmer />
          </MasterLayout>
        </ProtectedRoute>
      }
    />
    <Route
      path="/farmer/edit/:id"
      element={
        <ProtectedRoute>
          <MasterLayout>
            <EditFarmer />
          </MasterLayout>
        </ProtectedRoute>
      }
    />
  </>
);

export default farmerRoutes;